import { fetcher } from '@commenda/utils';

export async function manuallyTriggerMailroomSync(
  mailroomId: string
): Promise<{ success: boolean; message: string }> {
  const res = await fetcher(
    `mailroom/admin/${mailroomId}/manually-trigger-mailroom-sync`,
    {
      method: 'POST',
    }
  );

  try {
    if (!res.ok) {
      return {
        success: false,
        message: 'Failed to trigger mailroom sync.',
      };
    }

    return {
      success: true,
      message: 'Mailroom sync triggered successfully.',
    };
  } catch (err) {
    console.error(err);
    return {
      success: false,
      message: 'Failed to trigger mailroom sync.',
    };
  }
}


